/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useContext, useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import QuestionItem from './components/QuestionItem';
import { URLContext } from '../../contexts/URLContext';
import Loader from '../components/Loader';

const SectionContainer = styled.div`
  padding: 16px;
  padding-top: 70px;
`;

const FAQ = () => {
  const { baseURL } = useContext(URLContext);
  const [faqData, setFaqData] = useState(null);
  const [ isLoaded, setIsLoaded ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    fetch( baseURL + 'faq.json' )
    // fetch( './faq.json' )
      .then( (response) => response.json())
      .then(data => {
        setFaqData(data);
        setIsLoaded(true);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Erro ao carregar as informações");
      });

    return () => {
      controller.abort();
    }
  }, [baseURL])

  return (
    <>
      {!isLoaded ? (
        <Loader message={errorMessage} />
      ) : (
        <SectionContainer>
          <Typography variant="h6" component="h2" className="bold-text" align="center" style={{ margin: "16px 0 24px" }}>
            FAQ - Perguntas Frequentes
          </Typography>
          {faqData && faqData.map((q, index) => (
            <QuestionItem 
            key={index}
            title={q.title}
            content={q.content}
            isTable={q.isTable}
            headers={q.headers}
            data={q.data}
            />
          ))}
        </SectionContainer>
      )}
    </>
  );
};

export default FAQ;